import React from "react";
import { cn } from "ui/lib/utils";

type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Read by screen readers; icon-only buttons have no other name. */
  label: string;
};

/**
 * An icon-only button that is 36px for a mouse and 44px on touch, the
 * smallest target a finger hits reliably.
 */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, className, type = "button", children, ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={cn(
        "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-white/70 transition-colors [@media(pointer:coarse)]:h-11 [@media(pointer:coarse)]:w-11 hover:bg-white/[0.06] active:bg-white/[0.1] disabled:pointer-events-none disabled:opacity-40",
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
);
IconButton.displayName = "IconButton";
